const state = {
  statusMultipage: 'dit is een multipage'
}

// getters
const getters = {
  statusMultipage: state => state.statusMultipage
}

// actions
const actions = {}

// mutations
const mutations = {
  mutateStatus(state, status) {
    state.statusMultipage = status
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
